import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { getMediaBaseUrl } from "../../utils/backendUrl";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = getMediaBaseUrl();

const LostFoundSlider = () => {
  const [current, setCurrent] = useState(0);
  const [allSlides, setAllSlides] = useState([]);
  const intervalRef = useRef(null);

  // ================= FETCH DATA =================
  useEffect(() => {
    axios
      .get(`${BACKEND_URL}message`)
      .then((res) => {
        const slides = res.data.map((item) => ({
          id: item.id,
          title: item.title,
          subtitle: "",
          description: item.video_url || "",
          image: item.image
            ? `${BASE_URL}/uploads/messages/${item.image}`
            : "/no-image.png",
        }));

        setAllSlides(slides);
        setCurrent(0);
      })
      .catch((err) => console.error(err));
  }, []);

  // ================= AUTO SLIDE =================
  useEffect(() => {
    if (!allSlides.length) return;

    startAutoSlide();

    return () => stopAutoSlide();
  }, [allSlides]);

  const startAutoSlide = () => {
    stopAutoSlide(); // prevent duplicate intervals

    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % allSlides.length);
    }, 4000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // ================= ARROW CONTROLS =================
  const prevSlide = () => {
    if (!allSlides.length) return;

    stopAutoSlide();

    setCurrent((prev) =>
      prev === 0 ? allSlides.length - 1 : prev - 1
    );

    startAutoSlide();
  };

  const nextSlide = () => {
    if (!allSlides.length) return;

    stopAutoSlide();

    setCurrent((prev) =>
      (prev + 1) % allSlides.length
    );

    startAutoSlide();
  };

  return (
    <section>
      {/* HERO SECTION SAME */}
      <div className="relative h-[340px] w-full">
        <img
          src="https://media.gettyimages.com/id/541903912/video/4k-red-streaks-light-animation-background-seamless-loop.jpg?s=640x640&k=20&c=kCVmgkIPd6KHWRuIrOUbXyF38j8lHwumkQXjmCkodhQ="
          alt="contact"
          className="w-full h-full object-containt"
        />
        <div className="absolute inset-0 bg-brand-red/70 flex flex-col items-center justify-center text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl font-bold">
            Advertising Our
          </h1>
          <p className="mt-4 max-w-xl text-gray-300 text-sm">
            News tips, feedback & advertising.
          </p>
        </div>
      </div>

      {/* SLIDER SAME DESIGN */}
      <div className="max-w-7xl mx-auto py-20 px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="space-y-6 transition-all duration-500">
          <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight text-white uppercase">
            {allSlides[current]?.title}
            <br />
            {allSlides[current]?.subtitle}
          </h1>

          <p className="text-gray-400 text-lg max-w-xl">
            {allSlides[current]?.description}
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-lg">
            <img
              key={current}   // 🔥 force strict re-render sync
              src={allSlides[current]?.image}
              alt="Newspaper Ad"
              className="w-full h-[420px] object-contain transition-all duration-700"
            />
          </div>

          <button
            onClick={prevSlide}
            className="absolute -left-12 top-1/2 -translate-y-1/2 text-[20px]"
          >
            ❮
          </button>

          <button
            onClick={nextSlide}
            className="absolute -right-12 top-1/2 -translate-y-1/2 text-[20px]"
          >
            ❯
          </button>
        </div>
      </div>
    </section>
  );
};

export default LostFoundSlider;
